import * as yup from 'yup';

import { currencyToNumber } from '@helpers/masks';

export const productCostPercentageSchema = yup.object().shape({
  cost: yup
    .string()
    .required('É necessário informar uma porcentagem.')
    .test('min and max value', 'A porcentagem precisa ser entre 0% a 100%.', value => {
      return currencyToNumber(value || '') >= 0 && currencyToNumber(value || '') <= 100;
    }),
});

export const productCostFixedSchema = yup.object().shape({
  cost: yup.string().required('É necessário informar um valor.'),
});
